import { createSelector } from 'reselect';

const previewRootSelector = state => state;

const stateSelector = createSelector(
  previewRootSelector,
  productAttribute => ({
    categoriesAttributesFetching: productAttribute.categoriesAttributesFetching,
    categoriesAttributes: productAttribute.categoriesAttributes,
  }),
);

export const productAttributeSelector = createSelector(
  stateSelector,
  state => ({
    ...state,
  }),
);

export default {
  productAttributeSelector,
};
